import { MdCheckCircle, MdErrorOutline, MdRadioButtonUnchecked } from 'react-icons/md'

import { cx } from '@/Ship/Helpers/cssClass'

import styles from './PasswordRules.module.css'

import type { ReactNode } from 'react'

export interface PasswordRule {
    key: string
    label: ReactNode
    /** Вимогу виконано */
    done: boolean
    /** Вимогу порушено явно (наприклад, підтвердження не збігається) */
    failed?: boolean
    /** Текст замість label, коли failed */
    failedLabel?: ReactNode
}

interface PasswordRulesProps {
    rules: PasswordRule[]
}

/** Вимоги до пароля під полями з позначками: не виконано / виконано / порушено */
export const PasswordRules = ({ rules }: PasswordRulesProps) => (
    <ul className={cx(styles, 'rules')} aria-live="polite">
        {rules.map((rule) => {
            const Icon = rule.done ? MdCheckCircle : rule.failed ? MdErrorOutline : MdRadioButtonUnchecked
            return (
                <li
                    key={rule.key}
                    className={`${cx(styles, 'rule')} ${rule.done ? cx(styles, 'ruleDone') : ''} ${rule.failed ? cx(styles, 'ruleFailed') : ''}`}
                >
                    <Icon className={cx(styles, 'ruleIcon')} aria-hidden="true" />
                    {rule.failed ? (rule.failedLabel ?? rule.label) : rule.label}
                </li>
            )
        })}
    </ul>
)
